import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CrewToastContainer = () => {
  return (
    <ToastContainer
      autoClose={3000}
      closeOnClick
      hideProgressBar
      newestOnTop={false}
      pauseOnFocusLoss
      pauseOnHover
      position='top-center'
      rtl={false}
      closeButton={false}
      toastStyle={{
        background: 'transparent',
        boxShadow: 'none',
        padding: 0,
        margin: '8px 0',
        border: 'none',
        borderRadius: 0,
        minHeight: 'auto'
      }}
      style={{
        zIndex: 10000,
        marginTop: '20px'
      }}
    />
  );
};

export default CrewToastContainer;
